import { permissions } from './permissions';

export const topMenu = {
    system: [
        {
            label: 'Home',
            key: 'home',
            to: '/'
        },
        {
            label: 'Administration',
            key: 'administration',
            hideInProduction: false,
            subMenu: [
                {
                    isGroup: true,
                    label: 'Places',
                    groupItems: [
                        {
                            label: 'Cities',
                            to: 'cities',
                            role: permissions.cities.view
                        },
                        {
                            label: 'States',
                            to: 'states',
                            role: permissions.states.view
                        },
                        {
                            label: 'Countries',
                            to: 'countries',
                            role: permissions.countries.view
                        },
                        {
                            label: 'Regions',
                            to: 'regions',
                            role: permissions.regions.view
                        },
                        {
                            label: 'Sea Ports',
                            to: 'sea-ports',
                            role: permissions.seaPorts.view
                        }
                    ]
                },
                {
                    isGroup: true,
                    label: 'Transporters',
                    groupItems: [
                        {
                            label: 'Carriers',
                            to: 'carriers',
                            role: permissions.carriers.view
                        },
                        {
                            label: 'Vehicles',
                            to: 'vehicles',
                            role: permissions.vehicles.view
                        },
                        {
                            label: 'Transporters',
                            to: 'transporters',
                            role: permissions.transporters.view
                        },
                        {
                            label: 'Local Transporters',
                            to: 'local-transporters',
                            role: permissions.localTransporters.view
                        }
                    ]
                },
                {
                    isGroup: true,
                    label: 'Tariffs',
                    groupItems: [
                        {
                            label: 'Warehouse rate',
                            to: 'warehouse-tariff',
                            role: permissions.warehouseRate.view
                        },
                        {
                            label: 'Shipment rate',
                            to: 'shipment-tariff',
                            role: permissions.shipmentRate.view
                        }
                    ]
                },
                {
                    isGroup: true,
                    label: 'Settings',
                    groupItems: [
                        {
                            label: 'Agencies',
                            to: 'agencies',
                            role: permissions.agencies.view
                        },
                        {
                            label: 'Account',
                            to: 'accounts',
                            role: ['ROLE_ADMIN']
                        },
                        {
                            label: 'Agents',
                            to: 'agents',
                            role: ['ROLE_ADMIN']
                        },
                        {
                            label: 'Consolidated Type',
                            to: 'consolidated-type',
                            role: ['ROLE_ADMIN']
                        },
                        {
                            label: 'Template Packs',
                            to: 'template-packs',
                            role: ['ROLE_ADMIN']
                        },
                        {
                            label: 'Pack Types',
                            to: 'pack-types',
                            role: ['ROLE_ADMIN']
                        },
                        {
                            label: 'Paid Types',
                            to: 'paid-types',
                            role: ['ROLE_ADMIN']
                        },
                        {
                            label: 'Users',
                            to: 'users',
                            role: permissions.users.view
                        },
                        {
                            label: 'Terms & Conditions',
                            to: 'terms-and-conditions',
                            role: ['ROLE_ADMIN']
                        },
                        {
                            label: 'Body Email',
                            to: 'body-email',
                            role: ['ROLE_ADMIN']
                        },
                        {
                            label: 'Company',
                            to: 'company',
                            role: ['ROLE_ADMIN']
                        },
                        {
                            label: 'Correlative',
                            to: 'correlative',
                            role: ['ROLE_ADMIN']
                        },
                        {
                            label: 'Deployment configuration',
                            to: 'config-deployment',
                            role: ['ROLE_ADMIN']
                        },
                        {
                            label: 'Label configuration',
                            to: 'config-label',
                            role: ['ROLE_ADMIN']
                        },
                        {
                            label: 'Email setup',
                            to: 'email-setup',
                            role: ['ROLE_ADMIN']
                        },
                        {
                            label: 'Public Links',
                            to: 'public-links',
                            role: ['ROLE_ADMIN']
                        },
                        {
                            label: 'Services',
                            to: 'service',
                            role: ['ROLE_ADMIN']
                        },
                        {
                            label: 'Whatsapp Templates',
                            to: 'whatsapp-templates',
                            role: ['ROLE_ADMIN']
                        },
                        {
                            label: 'Status',
                            to: 'step-status',
                            role: ['ROLE_ADMIN']
                        }
                    ]
                },
                {
                    isGroup: true,
                    label: 'Warehouse Management',
                    groupItems: [
                        {
                            label: 'Zones',
                            to: 'zones',
                            role: permissions.zones.view
                        },
                        {
                            label: 'Locations',
                            to: 'locations',
                            role: permissions.locations.view
                        },
                        {
                            label: 'Branches',
                            to: 'branches',
                            role: permissions.branches.view
                        }
                    ]
                },
                {
                    isGroup: true,
                    label: 'Third-Party Apps',
                    groupItems: [
                        {
                            label: 'QuickBooks',
                            to: 'quickbooks-setup',
                            role: ['ROLE_ADMIN'],
                            integrationKey: 'QUICKBOOKS'
                        },
                        {
                            label: 'Zoom Envios',
                            to: 'zoom-carrier-setup',
                            role: ['ROLE_ADMIN'],
                            integrationKey: 'ZOOM_CARRIER'
                        }
                    ]
                }
            ]
        }
        // {
        //     label: 'Subscription',
        //     key: 'subscription',
        //     subMenu: [
        //         {
        //             label: 'Plan',
        //             to: '#'
        //         },
        //         {
        //             label: 'Payments',
        //             to: '#'
        //         }
        //     ]
        // }
    ]
};
